import React, { useState } from 'react'
import Filters from './Filters'
import Jobs from './Jobs'

const DataProtection = ({ customers }) => {
  const [loading, setLoading] = useState(true)
  const [filters, setFilters] = useState({
    customers: [],
    storagePolicies: [],
    locations: [],
    commcells: [],
    subclients: [],
    jobTypes: [],
    statuses: [],
    outOfSchedule: {}
  })

  return (
    <div>
      <Filters
        filters={filters}
        setFilters={setFilters}
        customers={customers}
        tableLoading={loading}
      />
      
      <Jobs
        filters={filters}
        setLoading={setLoading}
        loading={loading}
      />
    </div>
  )
}

export default DataProtection
